import { LegalBrandGuideLinesPage } from './LegalBrandGuideLinesPage';

export default LegalBrandGuideLinesPage;
